export const showNewFeatureForLocal = (): boolean =>
	process.env.NEXT_PUBLIC_NSK_ENV === "development";

export const showNewFeatureExcludePrd = (): boolean =>
	process.env.NEXT_PUBLIC_NSK_ENV !== "production";
